import { IReferralExternal } from './referral-external.interface';
import { IPersonalParticular } from './personal-particular.interface';

export interface IExternalCobrokeReferral {
  id: number;
  agentId: number;
  agent: IReferralExternal;
  formula: string;
}
